<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('organizations')">Empresas</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.ruc" :error="form.errors.ruc" class="pr-6 pb-8 w-full lg:w-2/6" label="Ruc" />
          <text-input v-model="form.tradename" :error="form.errors.tradename" class="pr-6 pb-8 w-full lg:w-2/6" label="Nombre Comercial" />
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-2/6" label="Nombre" />
          <text-input v-model="form.representation" :error="form.errors.representation" class="pr-6 pb-8 w-full lg:w-2/6" label="Representante Legal" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-2/6" label="Email" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-2/6" label="Phone" />
          <select-input v-model="form.city_id" :error="form.errors.city_id" class="pr-6 pb-8 w-full lg:w-2/6" label="Provincia">
            <option v-for="city in cities" :key="city.id" :value="form.city_id">{{ city.name}}</option>
          </select-input>
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-4/6" label="Address" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Empresa</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Crear Empresa' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    cities: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        phone: null,
        address: null,
        city_id: null,
        ruc: null,
        representation: null,
        tradename: null,
        status: 1,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('organizations.store'))
    },
  },
}
</script>
